import react, { useState, createContext, useEffect } from 'react';
export const Context = createContext({ loginAccount: false,onLogoutAccount: () => { }, onLoginAccount: () => { }, onRegister: () => { } });

export const AccountProvider = ({ children }) => {
    const [loginAccount, setLoginAccount] = useState(false);
    var accountArray = JSON.parse(localStorage.getItem("accountArray"));
    var isLogin = JSON.parse(localStorage.getItem("isLogin"));

    
    const handleLogin = (values) => {
        const email = values.email;
        const password = values.password;

        var accountNew = {
            "email": email,
            "password": password
        };
        var currentUser = accountArray.filter(user => user.email === accountNew.email);
        if (currentUser.length > 0) {
            if (currentUser[0].password === accountNew.password) {
                localStorage.setItem("userLogin", JSON.stringify(currentUser[0]));
                setLoginAccount(true);
                localStorage.setItem('isLogin', true);
                
            } else {
                alert('Password không chính xác')
            }

        } else {
            alert('Tài khoản không tồn tại')
        }

    }

    const handleLogout = () => {
        setLoginAccount(false);
        localStorage.removeItem('isLogin');
        localStorage.removeItem('userLogin');
    }

    const handleRegister = (values) => {
        const username = values.fullname;
        const email = values.email;
        const password = values.password;

        if (accountArray == null) accountArray = [];
        var accountNew = {
            "username": username,
            "email": email,
            "password": password
        };
        var currentUser = accountArray.filter(user => user.email === accountNew.email);

        if (currentUser.length < 1) {
            setLoginAccount(true);

            localStorage.setItem('isLogin', true);
            localStorage.setItem("accountNew", JSON.stringify(accountNew));
            localStorage.setItem("userLogin", JSON.stringify(accountNew));
            accountArray.push(accountNew);
            localStorage.setItem("accountArray", JSON.stringify(accountArray));
        } else {
            alert("Tài khoản đã tồn tại");
        }

    }
    useEffect(() => {
        
        if (isLogin) {
            setLoginAccount(true);
        }
        else {
            setLoginAccount(false)
        }
        setTimeout(() => {
            handleLogout()
        }, 7200);
    }, [])
    return <Context.Provider value={{ loginAccount: loginAccount, onLogoutAccount: handleLogout, onLoginAccount: handleLogin, onRegister: handleRegister }}>{children}</Context.Provider>;
}
export const AccountConsumer = Context.Consumer